module.exports = __webpack_public_path__ + "70275fe3104cf1d3388586ad8ffd478e.svg";